<template>
  <v-container fluid>
    <v-sheet
        v-if="!loaded"
        :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`"
        class="px-3 pt-3 pb-3">
      <v-row dense>
        <v-col cols="3">
          <v-skeleton-loader
              class="mx-auto"
              max-width="300"
              type="card"/>
        </v-col>
        <v-col cols="3">
          <v-skeleton-loader
              class="mx-auto"
              max-width="300"
              type="card"/>
        </v-col>
        <v-col cols="3">
          <v-skeleton-loader
              class="mx-auto"
              max-width="300"
              type="card"/>
        </v-col>
        <v-col cols="3">
          <v-skeleton-loader
              class="mx-auto"
              max-width="300"
              type="card"/>
        </v-col>
        <v-col cols="11" style="margin:2em">
          <v-skeleton-loader
              class="mx-auto"
              type="table"/>
        </v-col>
        <v-col cols="11" style="margin:2em">
          <v-skeleton-loader
              class="mx-auto"
              type="table"/>
        </v-col>
      </v-row>
    </v-sheet>
    <v-row dense v-else>
      <trimestral-card :title="'1er trimestre '+year" :data="this.firstTrimestre"/>
      <trimestral-card :title="'2º trimestre '+year" :data="this.secondTrimestre"/>
      <trimestral-card :title="'3er trimestre '+year" :data="this.thirdTrimestre"/>
      <trimestral-card :title="'4º trimestre '+year" :data="this.fourthTrimestre"/>

      <pending-projects :projects="projects"/>
      <pending-budgets :budgets="budgets" :refresh="refreshData"/>
      <pending-invoices :invoices="invoices" :refresh="refreshData"/>
    </v-row>
  </v-container>
</template>

<script>
import trimestralCard from "../components/home/trimestralCard";
import pendingBudgets from "../components/home/pendingBudgets";
import pendingInvoices from "../components/home/pendingInvoices";
import PendingProjects from "@/components/home/pendingProjects";

export default {
  name: 'Home',
  inject: ['theme'],
  components: {
    PendingProjects,
    trimestralCard,
    pendingBudgets,
    pendingInvoices
  },
  data() {
    return {
      firstTrimestre: 0,
      secondTrimestre: 0,
      thirdTrimestre: 0,
      fourthTrimestre: 0,
      invoices: [],
      budgets: [],
      projects:[],
year:2023,
      loaded: false,
      labels: [
        '1er trimestre',
        '2º trimestre',
        '3er trimestre',
        '4º trimestre',
      ],
      tab: 0,
      items: [
        'Proyectos abiertos', 'Resumen anual'
      ],
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      let url = this.base_url + '/invV2/admin/infohome/'+this.year+'/' + localStorage.token;
      this.axios.get(url).then(response => {
        if (response.data.first != null) this.firstTrimestre = response.data.first;
        if (response.data.second != null) this.secondTrimestre = response.data.second;
        if (response.data.third != null) this.thirdTrimestre = response.data.third;
        if (response.data.fourth != null) this.fourthTrimestre = response.data.fourth;
        this.invoices = response.data.invoices;
        this.budgets = response.data.budgets;
        this.projects = response.data.projects;
        this.chartBudgets = response.data.chartBudgets[0];
        this.loaded = true;
      });
    },
    refreshData(){
      let url = this.base_url + '/invV2/admin/infohome/'+this.year+'/' + localStorage.token;
      this.axios.get(url).then(response => {
        this.invoices = response.data.invoices;
        this.budgets = response.data.budgets;
        this.loaded = true;
      });
    }
  }
}
</script>